import React from "react";
import { useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Button } from "../atoms/button";

export const CookieBanner = () => {
  const [hasCookie, setHasCookie] = useState(true);
  const {
    palette: {
      primary: { main },
    },
  } = useTheme();
  useEffect(() => {
    const time = localStorage.getItem("consent");
    setHasCookie(!!time);
  }, []);
  const consent = () => {
    localStorage.setItem("consent", String(Date.now()));
    setHasCookie(true);
  };
  if (hasCookie) {
    return null;
  }
  return (
    <Box
      sx={{
        position: "fixed",
        display: "flex",
        alignItems: "center",
        bottom: 0,
        left: 0,
        right: 0,
        py: 2,
        px: 2,
        backgroundColor: "background.paper",
        boxShadow: "0 0.25rem 0.25rem 0.25rem rgba(0,0,0,0.25)",
        flexWrap: {
          xs: "wrap",
          sm: "nowrap",
        },
        svg: {
          width: "3rem",
          height: "3rem",
          flexBasis: "3rem",
          flexShrink: 0,
          fill: main,
          mr: 2,
          display: {
            xs: "none",
            sm: "block",
          },
        },
      }}
    >
      <svg viewBox="0 0 122.88 122.25" xmlns="http://www.w3.org/2000/svg">
        <path d="m101.77 49.38c2.09 3.1 4.37 5.11 6.86 5.78 2.45.66 5.32.06 8.7-2.01 1.36-.84 3.14-.41 3.97.95.28.46.42.96.43 1.47.13 1.4.21 2.82.24 4.26.03 1.46.02 2.91-.05 4.35 0 .13-.01.26-.03.38-.91 16.72-8.47 31.51-20 41.93-11.55 10.44-27.06 16.49-43.82 15.69v.01c-.13 0-.26-.01-.38-.03-16.72-.91-31.51-8.47-41.93-20-10.45-11.55-16.49-27.06-15.69-43.82 0-.13.01-.26.03-.38.9-16.74 8.71-31.61 20.47-42.09 11.77-10.5 27.52-16.6 44.28-15.8 1.6 0 2.89 1.29 2.89 2.89 0 .4-.08.78-.23 1.12-1.17 3.81-1.25 7.34-.27 10.14.89 2.54 2.7 4.51 5.41 5.52 1.44.54 2.2 2.1 1.74 3.55h.01c-1.83 5.89-1.87 11.08-.52 15.26.82 2.53 2.14 4.69 3.88 6.4 1.74 1.72 3.9 3 6.39 3.78 4.04 1.26 8.94 1.18 14.31-.55 1.27-.4 2.62.12 3.31 1.2zm-42.49 8.48c2.77 0 5.01 2.24 5.01 5.01s-2.24 5.01-5.01 5.01-5.01-2.24-5.01-5.01 2.25-5.01 5.01-5.01zm-21.72 20.63c3.37 0 6.11 2.73 6.11 6.11s-2.73 6.11-6.11 6.11-6.11-2.73-6.11-6.11 2.73-6.11 6.11-6.11zm13.16-46.74c2.65 0 4.79 2.14 4.79 4.79s-2.14 4.79-4.79 4.79-4.79-2.14-4.79-4.79 2.15-4.79 4.79-4.79zm68.58.65c1.98 0 3.58 1.6 3.58 3.58s-1.6 3.58-3.58 3.58-3.58-1.6-3.58-3.58c-.01-1.97 1.6-3.58 3.58-3.58zm-25.68-9.49c2.98 0 5.39 2.41 5.39 5.39s-2.41 5.39-5.39 5.39-5.39-2.41-5.39-5.39c0-2.97 2.41-5.39 5.39-5.39zm4.17-22.32c3.19 0 5.78 2.59 5.78 5.78s-2.59 5.78-5.78 5.78-5.78-2.59-5.78-5.78c.01-3.2 2.59-5.78 5.78-5.78zm-21.06 80.04c4.43 0 8.03 3.59 8.03 8.03 0 4.43-3.59 8.03-8.03 8.03s-8.03-3.59-8.03-8.03 3.59-8.03 8.03-8.03zm-44.82-33.85c4.8 0 8.69 3.89 8.69 8.69s-3.89 8.69-8.69 8.69-8.69-3.89-8.69-8.69c0-4.79 3.89-8.69 8.69-8.69zm75.22 13.96c-3.39-.91-6.35-3.14-8.95-6.48-5.78 1.52-11.16 1.41-15.76-.02-3.37-1.05-6.32-2.81-8.71-5.18s-4.21-5.32-5.32-8.75c-1.51-4.66-1.69-10.2-.18-16.32-3.1-1.8-5.25-4.53-6.42-7.88-1.06-3.05-1.28-6.59-.61-10.35-13.91.19-26.88 5.6-36.77 14.42-10.67 9.51-17.75 22.97-18.57 38.11v.05l-.01.13c-.76 15.25 4.72 29.35 14.19 39.83 9.44 10.44 22.84 17.29 38 18.1h.05l.13.01c15.24.77 29.35-4.71 39.83-14.19 10.44-9.44 17.29-22.84 18.1-38v-.05l.01-.13c.07-1.34.09-2.64.06-3.91-3.22 1.21-6.24 1.38-9.07.61z" />
      </svg>
      <Typography sx={{ flexGrow: 1 }} variant="body2">
        Ce site utilise des cookies indispensables à son fonctionnement : pour
        gérer votre panier et le paiement de votre commande.
        <br />
        Nous utilisons également un service de mesure d'audience afin
        d'optimiser votre expérience utilisateur.
      </Typography>
      <Box
        sx={{
          ml: { xs: 0, sm: 2 },
          mt: { xs: 2, sm: 0 },
          whiteSpace: "nowrap",
          flexBasis: { xs: "100%", sm: "8rem" },
        }}
      >
        <Button onClick={() => consent()}>Accepter</Button>
      </Box>
    </Box>
  );
};
